import { render, staticRenderFns } from "./raskDetail.vue?vue&type=template&id=c4d2331e&scoped=true&"
import script from "./raskDetail.vue?vue&type=script&lang=js&"
export * from "./raskDetail.vue?vue&type=script&lang=js&"
import style0 from "./raskDetail.vue?vue&type=style&index=0&id=c4d2331e&scoped=true&lang=less&"
import style1 from "./raskDetail.vue?vue&type=style&index=1&id=c4d2331e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d2331e",
  null
  
)

export default component.exports